import React, { Component, useImperativeHandle } from "react";
// import DataTable from 'react-data-table-component';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Form, Table} from 'react-bootstrap';
import ConsultationService from '../../services/consultation.service'
import BlockUI from '../shared/BlockUI/blockUI'

class FindReceiptModal extends Component {

    constructor(props){
        super(props)
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.renderTableData = this.renderTableData.bind(this);
        this.renderTableHeader = this.renderTableHeader.bind(this);
        this.onClose = this.onClose.bind(this);
        this.clearState = this.clearState.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
       
        this.state = {
            error: null,
            isLoaded: false,
            items: null,
            searchType: 1,
            name: null,
            icno: null,
            selectedId: null,
            foundPatient: null,
            blocking: false
            };
    }

    isChecked = (id) => {
        let selectedId = this.state.selectedId;
        if(selectedId == id){
            return true;
        }

        return false;
    }

    changeHandler = (value, id, visitId, receiptNo) => {
        if (value) {
          //this.props.onSelect(id);
          this.setState({
            selectedId: id,
            visitId,
            receiptNo
          });
        } else {
            this.setState({
                selectedId: 0
              });
        }
      };
    renderTableHeader() {
        // let header = Object.keys(this.state.items[0])
        // return header.map((key, index) => {
        //    return <th key={index}>{key.toUpperCase()}</th>
        // })
        return (
            <tr>
                <th key="0">Select</th>
                <th key="1">Visit Date</th>
                <th key="2">Ic No</th>
                <th key="3">Name</th>
            </tr>
        );
     }
    renderTableData() {
        return this.state.items.map((patient, index) => {
           const { id, name, patientId, visitDate, visitId, receiptNo } = patient //destructuring
           return (
              <tr key={index}>
                 <td><input id={index} checked={this.isChecked(index)} type="checkbox" value={visitId} name="patient" onChange={e => this.changeHandler(e.target.checked, index, visitId, receiptNo)}/></td>
                 <td>{visitDate}</td>
                 <td>{patientId}</td>
                 <td>{name}</td>
               
              </tr>
           )
        })
     }
    
     handleChange = (state) => {
        // You can use setState or dispatch with something like Redux so we can use the retrieved data
        console.log('Selected Rows: ', state.selectedRows);
      };
    
    handleInputChange(event) {
        const target = event.target;
        const value =  target.value;
        const name = target.name;

         this.setState({
          [name]: value
        });    
    }

    clearState() {
        this.setState({
            searchType: 1,
            search: '',
            icno: '',
            name: '',
            items: [],
            selectedId:0
        })
    }
    onClose() {
        this.clearState()
        this.props.onHide({ msg: 'Modal Closed!' });
    }
    onSubmit(){
        if(this.state.selectedId == null){
            alert('Please select patient to print')
            return
        }
        this.props.onClick({ visitId: this.state.visitId, receiptNo: this.state.receiptNo });
        this.clearState();
    }
    handleSelect(event) {
        const target = event.target;
        const value =  target.value;
        const name = target.name;

        this.setState({
            searchType: value
        })
        
    }

    findReceipt = () => {

        if(this.state.search === undefined || this.state.search.trim().length === 0 ) {
            alert('Please type in search')
            return
        }
        let condition = {
            name: '',
            patientId: ''
        }
        if(this.state.searchType == 1){
            condition.name = this.state.search;
        }
        if(this.state.searchType == 2){
            condition.patientId= this.state.search;
        }
        this.setState({
            blocking: true
        })
        ConsultationService.getReceipt(condition).then(response => {
               this.setState({
                   items: response.data,
                   isLoaded: true,
                   blocking: false
               })
          
        })


    }

    render() {
       var result = this.state.isLoaded;
     
        return (
                <Modal  size="lg" backdrop="static" show={this.props.show} onHide={this.onClose}>

                    <Modal.Header closeButton>
                        <Modal.Title>
                            {this.props.title}
                        </Modal.Title>
                    </Modal.Header>

                    <Modal.Body style={{backgroundColor: "#e9edf3"}}>

                    <div className="row">
                            <div className="col-lg-3">
                                <Form.Group controlId="formType">
                                    <Form.Label>Search by:</Form.Label>
                                    <Form.Control as="select" onChange={this.handleSelect}>
                                    <option value="1">Name</option>
                                    <option value="2">Ic No</option>
                                </Form.Control>
                                </Form.Group>
                            </div>
                            <div className="col-lg-7">
                                <Form.Group controlId="formSearchValue">
                                    {/* <Form.Label>Doctor</Form.Label> */}
                                    <Form.Control style={{marginTop:"32px"}} type="text" name="search" placeholder="search" onChange={this.handleInputChange} />
                                </Form.Group>
                            </div>
                            <div className="col-lg-2">
                                <Form.Group controlId="formSearchValue">
                                <Button  style={{marginTop:"32px", float:"right"}} onClick={this.findReceipt} >Search</Button>
                                </Form.Group>
                            </div>
            
                    </div>
          
                    <h3 id='title'>Patients Information</h3>
                    <hr></hr>
                    {result ?( 
                        <Table responsive striped bordered hover size="sm" variant="dark">
                        <thead>
                            {this.renderTableHeader()}
                        </thead>
                        <tbody>
                            {this.renderTableData()}
                        </tbody>
                        </Table> ) : <div style={{margin: "0% 43%"}}>No records</div>
                    } 
                               

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.onClose} >Close</Button>
                        <Button variant="primary" onClick={this.onSubmit } >Select</Button>
                    </Modal.Footer>
                    <BlockUI blocking={this.state.blocking}></BlockUI>
                </Modal>
            
        )
     
    };
}

export default FindReceiptModal;